/* Component Dependencies */
var mapsTemplate = require('templates/maps.hbs');
var mapsCheckIn = require('templates/mapsCheckIn.hbs');
var AriesComponent = require('libs/aries-component');
var googleApiWrapper = require('js-google-api-wrapper');
var LoadingIndicator = require('utils/loading-indicator');
var MapConfig = require('libs/googleMapConfig');
var Popup = require('libs/popup');

AriesComponent.create({
  type: 'maps',
  template: {
    'maps': mapsTemplate,
    'mapsCheckIn': mapsCheckIn
  },
  bindEvents: function () {
    var _self = this;
    _self.tileData = _self.$el.find('.data-tile');
    if (_self.tileData.data('displayTile') && !_self.$el.hasClass('js-baidu-map')) {
      if(!_self.tileData.data('iseinterface')){
        _self.loadingIndicator = new LoadingIndicator(_self.$el);
        _self.loadingIndicator.addLoader('nofocus');
      }
      _self.loadMapsApi();
      _self.$modalSelector = _self.$el.find('.js-popup');
      _self.$modalSelector.on('mfpOpen', _self.onModalOpen.bind(_self));
      _self.$modalSelector.on('mfpClose', _self.onModalClose.bind(_self));
    } else {
      _self.baiduMapsInit();
      _self.$modalSelector = _self.$el.find('.js-popup');
      _self.$modalSelector.on('mfpOpen', _self.onModalOpen.bind(_self));
      _self.$modalSelector.on('mfpClose', _self.onModalClose.bind(_self));
    }
      var href = window.location.href,
      mapsparam= (href.split("?").length) >= 1  ? href.split("?")[1] : href;
      if(mapsparam==="maps"){
        if(_self.$el.find(".l-fullscreen-control").length){
          var stickyHeight = $('.m-hotel-info').height();
          setTimeout(function(){
            $('html,body').off().animate({scrollTop: _self.$el.offset().top - stickyHeight},'slow');
          },500);
        }
      }
  },
  /**
   * Load Baidu API and initialize Map component
   * @return {void}
   */
  baiduMapsInit: function _baiduMapsInit() {
    var _self = this;
    var zoomConfigLevel = _self.initFromModal ? 19 : 16;
    _self.bmap = new BMap.Map('js-baidu-map-container');
    _self.label = new BMap.Label('<div class="map-marker map-marker-default blank"><span class="room-type"></span><div class="map-rate-details"><span class="t-icon-bedding"></span></div><div class="arrow"></div></div>', {
      position: new BMap.Point(_self.$el.find("#js-baidu-map-container").data('longitude'), _self.$el.find("#js-baidu-map-container").data('latitude'))
    });
    _self.label.setStyles({
      'border': 'none',
      'background': 'transparent'
    });
    _self.bmap.centerAndZoom(new BMap.Point(_self.$el.find("#js-baidu-map-container").data('longitude'), _self.$el.find("#js-baidu-map-container").data('latitude')), zoomConfigLevel);
    _self.bmap.addOverlay(_self.label);
    _self.bmap.enableScrollWheelZoom();
    _self.bmap.addControl(
        new BMap.NavigationControl({
          anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
          type: BMAP_NAVIGATION_CONTROL_ZOOM
        })
    );
    _self.initFromModal = false;
    _self.registerModal();
  },
  /**
   * Load Google API and initialize Map on success callback
   * @return {void}
   */
  loadMapsApi: function () {
    var _self = this,
				href = window.location.href,
    queryParam = (href.split("?").length) >= 2  ? href.split("?")[1] : href,
				pageURl = href.split("?")[0];
    googleApiWrapper.loadApi(_self.tileData.data('googleMapApiUrl'))
      .then(function () {
        _self.markerWithLabel= require('markerwithlabel')(google.maps);
        _self.initHotelMap();
        _self.registerModal();
				if (queryParam === "m-maps-container") {
        _self.$el.closest('.modal-content').find('a:first,input[type!=hidden]:first').focus();
	   				window.history.replaceState({} ,href,pageURl);
        } else {
           _self.$el.closest('.modal-content').find('a:first,input[type!=hidden]:first').not('.l-maps-link a:first').focus();
        }
      });
  },
  /**
   * Initialize Map with Hotel marker
   * @return {void}
   */
  initHotelMap: function () {
    var _self = this, marker, eventIdleListener;
    _self.hotelLatLng = new google.maps.LatLng(_self.tileData.data('latitude'), _self.tileData.data('longitude'));
    _self.hotelMap = _self.getMap(_self.$el.find('.l-map-container')[0], _self.hotelLatLng);

    // add full screen control on map
    _self.hotelMap.controls[google.maps.ControlPosition.LEFT_TOP].push(_self.$el.find('.l-fullscreen-control')[0]);

    marker = _self.getMarker();
    marker.setMap(_self.hotelMap);

    //remove loader after map is rendered with marker
    eventIdleListener = google.maps.event.addListener(_self.hotelMap, "idle",
      function _eventIdleListener() {
        _self.handleMapEvent({removeLoader: true, listener: eventIdleListener});
      });
  },
  /**
   * Initialise map with hotel latitude and longitude
   * @param {HTMLElement} mapContainerElm - Map container DOM element
   * @return {Object} google.maps.Map object
   */
  getMap: function (mapContainerElm) {
    var _self = this, map;
    var isQuickView = this.$el.data('quickview') ? true : false;
    map = new google.maps.Map(mapContainerElm, {
      zoom: MapConfig.markerZoomLevel,
      center: _self.hotelLatLng,
      disableDefaultUI: true,
      zoomControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      streetViewControl: true,
      streetViewControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      mapTypeControl: true,
      mapTypeControlOptions: {
        mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.SATELLITE],
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
        position: google.maps.ControlPosition.TOP_LEFT
      },
      fullscreenControl: isQuickView,
      fullscreenControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP
      }
    });
    return map;
  },
  /**
   * Initialize marker with brand icon
   * @return {Object} google.maps.Marker object with brand icon
   */
  getMarker: function () {
    var _self = this, marker, pushPinSpritePoint = 0, imageIcon, iconWidth, iconHeight;
    pushPinSpritePoint = MapConfig.pushPinSpritePoint[_self.tileData.data('brandCode')] || pushPinSpritePoint;
    iconWidth = Math.floor(MapConfig.pushPinIcon.width * MapConfig.pushPinIcon.scaleSize);
    iconHeight = Math.floor(MapConfig.pushPinIcon.height * MapConfig.pushPinIcon.scaleSize);
    pushPinSpritePoint = Math.floor(pushPinSpritePoint * MapConfig.pushPinIcon.scaleSize);
    marker = new this.markerWithLabel({
      position: _self.hotelLatLng,
      labelContent: '<div class="map-marker map-marker-default blank"><span class="room-type"></span><div class="map-rate-details"><span class="t-icon-bedding"></span></div><div class="arrow"></div></div>',
      icon :{
          path: google.maps.SymbolPath.CIRCLE,
          scale: 0
      },
      labelAnchor: new google.maps.Point(Math.floor(iconWidth / 2), iconHeight),
      origin: new google.maps.Point(0, pushPinSpritePoint)
    });
    return marker;
  },
  /**
   * Register Modal for to show hotel map in full screen
   * @return {void}
   */
  registerModal: function () {
    var fullscreenSourceBlock = this.$el.data('quickview') ? '.quickview-modal-content' : '.modal-content'; 
    var fullScreenPopup = new Popup({
      items: {
        src: fullscreenSourceBlock,
        type: 'inline'
      },
      selector: '.tile-maps .js-popup',
      mainClass: 'mi-gallery mi-gallery-full',
      alternateCloseMarkup: true,
      fullScreen: true
    });
    fullScreenPopup.register();
  },
  /**
   * Recenter map when modal is opened
   * @return {void}
   */
  onModalOpen: function () {
    var _self = this, eventIdleListener;
    _self.initFromModal = true;
    _self.$el.addClass('is-fullscreen');
    _self.$el.closest('.mfp-content').addClass('l-max-width-max').css('border-radius', 0);
    if(!_self.$el.hasClass('js-baidu-map')) {
      google.maps.event.trigger(_self.hotelMap, "resize");
      _self.hotelMap.setZoom(MapConfig.markerZoomLevel - 1);
      eventIdleListener = google.maps.event.addListener(_self.hotelMap, "idle",
        function _eventIdleListener() {
          _self.handleMapEvent({setCenter: true, listener: eventIdleListener});
      });
    } else {
      _self.baiduMapsInit();
      //_self.bmap.centerAndZoom(new BMap.Point(_self.label.point.lng, _self.label.point.lat), 15);
    }
  },
  /**
   * Recenter map when modal is closed
   * @return {void}
   */
  onModalClose: function () {
    var _self = this, eventIdleListener;
    _self.$el.removeClass('is-fullscreen');
    if(_self.tileData.data('iseinterface') && !_self.$el.hasClass('js-baidu-map')){
      _self.hotelMap.setMapTypeId(google.maps.MapTypeId.ROADMAP);
    }
    if(!_self.$el.hasClass('js-baidu-map')) {
      google.maps.event.trigger(_self.hotelMap, "resize");
      _self.hotelMap.setZoom(MapConfig.markerZoomLevel);
      eventIdleListener = google.maps.event.addListener(_self.hotelMap, "idle",
        function _eventIdleListener() {
          _self.handleMapEvent({setCenter: true, listener: eventIdleListener});
      });
    }
  },
  /**
   * Handle Google Map events
   * @param {Object} option object containing event listener
   * and boolean flags: removeLoader, setCenter
   * @return {void}
   */
  handleMapEvent: function (option) {
    var _self = this;
    if (option.removeLoader) {
      _self.loadingIndicator && _self.loadingIndicator.removeLoader();
    }
    if (option.setCenter) {
      setTimeout(function () {
        _self.hotelMap.setCenter(_self.hotelLatLng);
      }); 
    }
    google.maps.event.removeListener(option.listener);
  }
});
